import AbstractBaseError from './AbstractBaseError';

export default class ConfigurationException extends AbstractBaseError {
	name = 'ConfigurationException';
}
